<template>
  <!--公共底部固定栏-->
  <div id="bottom-fixed-bar">
    <router-link :to="{name: 'Index'}" class="discover" :class="{active : index === 0}">
      <img :src="index === 0 ? require('../../../assets/icon/home_icon_discover_1.png') : require('../../../assets/icon/home_icon_discover_0.png')" alt="">首页
    </router-link>
    <router-link :to="{name: 'Jsbs'}" class="choose" :class="{active : index === 1}">
      <img :src="index === 1 ? require('../../../assets/icon/home_icon_choose_1.png') : require('../../../assets/icon/home_icon_choose_0.png')" alt="">课程
    </router-link>
    <router-link :to="{name: 'ExamBank'}" class="practise" :class="{active : index === 2}">
      <img :src="index === 2 ? require('../../../assets/icon/home_icon_practise_1.png') : require('../../../assets/icon/home_icon_practise_0.png')" alt="">练习
    </router-link>
    <router-link :to="{name: 'PersonInfo'}" class="mine" :class="{active : index === 3}">
      <img :src="index === 3 ? require('../../../assets/icon/home_icon_mine_1.png') : require('../../../assets/icon/home_icon_mine_0.png')" alt="">我的
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'BottomBar',
  props: {
    index: 0
  }
}
</script>

<style scoped lang="stylus">
  #bottom-fixed-bar
    position: fixed
    bottom: 0
    left: 50%
    z-index: 10000
    display: flex
    justify-content: space-around
    align-items: center
    width: 7.5rem
    height: .98rem
    background-color: #fff
    margin-left: -3.75rem
    box-shadow:0rem 0rem 0.08rem 0rem rgba(230,230,230,0.5)
    a
      font-size: .2rem
      color: #4A5063
      text-align: center
      &.active
        color: #1E81F2
      img
        display: block
        width: .44rem
        height: .44rem
        margin: 0 auto
</style>



// WEBPACK FOOTER //
// src/components/share/fixed/BottomBar.vue